import React, { useEffect, useState } from 'react'
import { IMaskInput } from 'react-imask'

// Converte de "yyyy-mm-dd" para "dd/mm/yyyy"
const formatToDisplay = (isoDate) => {
  if (!isoDate) return ''
  const [year, month, day] = isoDate.split('-')
  return `${day}/${month}/${year}`
}

// Converte de "dd/mm/yyyy" para "yyyy-mm-dd"
const formatToIso = (brDate) => {
  const [day, month, year] = brDate.split('/')
  if (!day || !month || !year) return ''
  return `${year}-${month}-${day}`
}

const DateInput = ({ disabled = false, label, name, value, onChange, required = false }) => {
  const [localValue, setLocalValue] = useState('')

  useEffect(() => {
    setLocalValue(formatToDisplay(value)) // Sempre que a prop mudar, atualiza o local state
  }, [value])

  const handleAccept = (val) => {
    setLocalValue(val)
    const isoDate = formatToIso(val)
    onChange({ target: { name, value: isoDate } })
  }

  return (
    <div className="flex flex-col gap-1">
      {label && (
        <label htmlFor={name} className="text-lg text-blueDarker font-normal">
          {label}{required && <span className="ml-1.5">*</span>}
        </label>
      )}
      <IMaskInput
        id={name}
        name={name}
        required={required}
        value={localValue}
        mask="00/00/0000"
        disabled={disabled}
        onAccept={handleAccept}
        className="w-full border border-bluePale rounded-xl px-3 py-3 text-base placeholder-blueSteel"
        placeholder="dd/mm/aaaa"
      />
    </div>
  )
}

export default DateInput
